module.exports = __webpack_public_path__ + "static/img/optimiza-check.8f60df72.png";